export default __webpack_public_path__ + "static/media/start.a6340686.svg";